import { globalpermissions } from '../../Services/Permission';

/**
 * Footer account menu items (expanded sidebar user menu).
 * Phase 1: all visible except permission-gated logs entries still listed for Phase 2.
 *
 * @returns {Array<{ label: string, value: string, iconKey: string, permission?: string[] }>}
 */
export function buildUserMenuConfig() {
  return [
    {
      label: 'My Profile',
      value: '/r/management/profile',
      iconKey: 'person',
    },
    {
      label: 'Activity Logs',
      value: '/r/activity-logs',
      iconKey: 'history',
      permission: [globalpermissions?.navBar?.menuActivityLogs],
    },
    {
      label: 'View Logs',
      value: '/r/login-logs',
      iconKey: 'login',
      permission: [globalpermissions?.navBar?.menuLoginLogs],
    },
    {
      label: 'Change Password',
      value: '/r/management/change-password',
      iconKey: 'lock',
      permission: [globalpermissions?.navBar?.menuChangePassword],
    },
    {
      label: 'Account',
      value: '/r/management/account/edit',
      iconKey: 'accountCircle',
      permission: [globalpermissions?.navBar?.menuProfileAccount],
    },
    {
      label: 'Logout',
      value: '/#/logout',
      iconKey: 'logout',
    },
  ];
}
